import {CalculationGoldListQueryForm} from './calculation-gold.models';

export const queryKey = {
  all: ['calculation'] as const,
  gold: () => [...queryKey.all, 'gold'] as const,
  list: () => [...queryKey.gold(), 'list'] as const,
  listFilter: (query: CalculationGoldListQueryForm) => [...queryKey.list(), query] as const,
};
